import type { CoordinateDTO, ApiItem } from '@ui/shared/util-api';
import { locationToAddress, centerOfArea, Item } from '@ui/shared/util-api';

export class MapItem extends Item {
    public readonly shortDescription: string;
    public readonly address: Array<string>;
    public readonly shortAddress: string;
    public mapPointLocation: CoordinateDTO | undefined;
    public mapArea: Array<CoordinateDTO> | undefined = undefined;
    public iconPath = '';
    public iconLabel = '';

    constructor(
        mapItem: ApiItem,
        uniqueId?: string,
    ) {
        super(mapItem, uniqueId);

        this.shortDescription = mapItem.short_description ?? '';
        this.address = locationToAddress(mapItem.location);
        this.shortAddress = this.address.join(', ');
        this.mapPointLocation = mapItem.location?.coordinates;
    }

    public get mapCoordinates(): CoordinateDTO | null {
        if (this.mapPointLocation) {
            return this.mapPointLocation;
        }

        if (this.mapArea) {
            return centerOfArea(this.mapArea);
        }

        return null;
    }

    public get isArea(): boolean {
        return !!this.mapArea?.length;
    }
}
